import { Component, OnInit, HostListener, ViewChildren, QueryList, ElementRef, Output, EventEmitter } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { IAttributes } from 'src/app/models/IAttributes';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { ToastrService } from 'ngx-toastr';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { MatDialog } from '@angular/material';
import { IAlerts } from 'src/app/models/IAlerts';
import { warningDialogModel, WarningDialogComponent } from 'src/app/ChildControls/warning-dialog/warning-dialog.component';
import { DatePipe } from '@angular/common';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { Defaults } from 'src/app/Utilities/defaults';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';
import { IRole } from 'src/app/models/IRole';
import { Component_RoleMasterEnum, UserRoleservice } from 'src/app/Services/common.service';
import { AuditLog } from 'src/app/models/iauditlog.model';
declare var $: any;
@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class AlertsComponent implements OnInit {
  @Output() AlertsilderClose = new EventEmitter<string>();
  alertsInfo: IAlerts;
  AlertDetailsForm: FormGroup;
  lstAlertDetails: {};
  lstAlertsInfo: IAlerts[] = [];
  public lstAlertStatus: IAttributes[];
  public lstAlertPriority: IAttributes[];
  public lstPopUpAlerts: IAlerts[];
  public lstattrbutes: IAttributes[];
  public apriorityId: string;
  apriorityOptions: Observable<IAttributes[]>;
  public astatusId: string;
  astatusOptions: Observable<IAttributes[]>;
  public rolesList: IRole[];
  public lstRoles: IRole[];
  SelectedDropDownListId: string = '';
  SelectedDropDownListId1: boolean = false;
  dataSource = ELEMENT_DATA;
  popupVisible = false;
  alertId = 0;
  public result: any;
  isUserRolesApplied: boolean = false;
  columnsToDisplay = ['alertDetails', 'priority', 'effectiveDate', 'exprirationDate', 'userName', 'alertStatus', 'displayRoleName', 'Action'];

  headercolumnsToDisplay = ['Alert Details', 'Priority', 'Effective Date', 'Expiration Date', 'Created By', 'Status', 'Roles', 'Action'];
  expandedElement: PeriodicElement | null;

  public delAlertInfo: string = "";
  public show: boolean = false;
  activetab = 7;
  lockedUser: any;
  lockMessage: any;
  locationid: number;
  UserPermissions: string = "";
  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    // if (event.target.id == "rolesfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
    //   //this.SelectedDropDownListId = true;
    //   this.SelectedDropDownListId1 = false;
    // } 
    // // else if (event.target.id == "rolesfocus1" || event.currentTarget.activeElement.parentElement.id == "userselectLoc1") {
    // //   this.SelectedDropDownListId1 = true;
    // //   this.SelectedDropDownListId = false
    // // }
    // else {
    //   event.stopPropagation();
    //   //this.SelectedDropDownListId = false
    //   this.SelectedDropDownListId1 = false
    // }
    if (this.isshowDrugReactionFocusEnabled == false) {
      //$(".levelfocushideClass").hide();
      if (event.target.id.indexOf("rolesfocus") > -1) {
        var countval = event.target.id.replace("rolesfocus", "");
        var container = $("#rolesfocushideDrug" + countval);
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
          this.SelectedDropDownListId = "";
        }
      }
      else if (event.currentTarget.activeElement != null && event.currentTarget.activeElement != undefined && event.currentTarget.activeElement.parentElement.id != undefined
        && event.currentTarget.activeElement.parentElement.id.indexOf("roleslistoption") > -1) {
        var countval = event.currentTarget.activeElement.parentElement.id.replace("roleslistoption", "");
        var container = $("#rolesfocushideDrug" + countval);
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.show();
        }
      }
      else {
        this.SelectedDropDownListId = "";
        $(".rolesfocushideClass").hide();
      }
    }
    this.isshowDrugReactionFocusEnabled = false;
  }
  headerDispaly: boolean;
  headerCloseIcon: boolean;
  sessionheaderVisibility: any;
  sessionheaderIconVisibility: any;
  constructor(
    private fb: FormBuilder
    , private route: ActivatedRoute
    , private personalService: PersonalInfoService
    , private router: Router
    , public dialog: MatDialog
    // , private app: AppComponent
    , private toastr: ToastrService
    , private datePipe: DatePipe
    , private spinner: NgxSpinnerService
    , private sharedService: SharedService
    , private lockService: LockService
    , private _userRoleservice: UserRoleservice
    , private userService: UserManagementService) {
    this.isUserRolesApplied = Defaults.isUserRolesApplied
    //this.app.isLoggedIn$ = true;
    this.getSystem();
    this.checkLock();
    this.UserPermissions = this._userRoleservice.getPermissionsByComponentId(Component_RoleMasterEnum.Alerts);
    //check condition for visit note headers 
    if (sessionStorage.getItem("visitNoteAlertsheaderVisibility") != null || sessionStorage.getItem("visitNoteAlertsheaderVisibility") != undefined) {
      this.sessionheaderVisibility = sessionStorage.getItem("visitNoteAlertsheaderVisibility");
    }
    if (this.sessionheaderVisibility == "true") {
      this.headerDispaly = true;
    } else {
      this.headerDispaly = false;
    }
    if (sessionStorage.getItem("AlertsheaderIconVisibility") != null || sessionStorage.getItem("AlertsheaderIconVisibility") != undefined) {
      this.sessionheaderIconVisibility = sessionStorage.getItem("AlertsheaderIconVisibility");
    }
    if (this.sessionheaderIconVisibility == "true") {
      this.headerCloseIcon = true;
    } else {
      this.headerCloseIcon = false;
    }
  }



  formErrors = {
    'alertDetails': '',
    'alertEffectiveDate': '',
    //'alertExpirationDate': '',
  };

  validationMessages = {
    'alertDetails': {
      'required': 'Alert Details is required.'
    },
    'alertEffectiveDate': {
      'required': 'Effactive Date is required.'
    },
    // 'alertExpirationDate': {
    //   'required': 'Expiration Date is required.'
    // },
  };

  ngOnInit() {

    $(document).click(function (event) {
      //**Drug Allery reaction */
      if (event.target.id != "rolesfocus") {
        var container = $("#rolesfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
      if (event.target.id != "rolesfocusUpdate") {
        var container = $("#Updaterolesfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
    })

    if (this.spinner)
      this.spinner.hide();
    this.show = false;
    this.AlertDetailsForm = this.fb.group({
      alertDetails: ['', Validators.required],
      chkScheduling: [''],
      chkDemographics: [''],
      chkClinical: [''],

      chkVisitNote: [''],
      chkOrNote: [''],
      chkRx: [''],
      chkOrder: [''],
      //chkBilling: [''],
      //chkMa: [''],
      alertEffectiveDate: ['', Validators.required],
      alertExpirationDate: [''],
      alertPriority: [''],
      alertStatus: [''],
      roles: [''],
      isChkRoles: [''],
    });
    //this.getRoles();
    //  this.AlertDetailsForm.patchValue({
    //     alertEffectiveDate:new Date(),

    //   });

    this.alertsDropdownBinding();
    this.AlertDetailsForm.markAllAsTouched();
    this.AlertDetailsForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.AlertDetailsForm);

    });

    this.alertsInfo = {
      alertId: null,
      patId: null,
      alertDetails: '',
      effectiveDate: null,
      exprirationDate: null,
      priorityId: null,
      priority: '',
      alertStatusId: null,
      alertStatus: '',
      isActive: false,
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      facilityId: null,
      isScheduling: null,
      isDemographics: null,
      isClinical: null,
      isBilling: null,
      isMA: null,
      isDismiss: null,
      userName: '',
      selectedalertscategories: '',
      roles: '',
      isRole: null,
      rolesName: '',
      displayRoleName: '',
      isVisitNote: null,
      isOrNote: null,
      isRx: null,
      isOrderNote: null,
      IsRCMAlert:null,
    };

    this.route.paramMap.subscribe(params => {
      const personId = CommonComponents.patientId;
      if (personId) {
        this.getAlertsInfo(personId, this.locationid);
      } else {
        this.alertsInfo = {
          alertId: null,
          patId: null,
          alertDetails: '',
          effectiveDate: null,
          exprirationDate: null,
          priorityId: null,
          priority: '',
          alertStatusId: null,
          alertStatus: '',
          isActive: false,
          createdBy: '',
          createdOn: null,
          modifiedBy: '',
          modifiedOn: null,
          facilityId: null,
          isScheduling: null,
          isDemographics: null,
          isClinical: null,
          isBilling: null,
          isMA: null,
          isDismiss: null,
          userName: '',
          selectedalertscategories: '',
          roles: '',
          isRole: null,
          rolesName: '',
          displayRoleName: '',
          isVisitNote: null,
          isOrNote: null,
          isRx: null,
          isOrderNote: null,
          IsRCMAlert:null,
        };
      }
    });
    this.getRoles();
  }
  avoidspaceatfirst(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }
  getRoles() {
    this.userService.getRoles().subscribe(data => {
      var rolesall = data.filter(rol => rol.roleName != 'Patient');
      this.rolesList = rolesall;
      this.lstRoles = rolesall;
      //  this.DefaultRoleschecked();
    });
  }

  alertsDropdownBinding() {
    // if (this.sharedService.lstattrbutes != null && this.sharedService.lstattrbutes.length > 0) {
    //   this.lstAlertPriority = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '15');
    //   this.lstAlertStatus = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '20');
    // }

    this.sharedService.getAttributes().subscribe(data => {
      this.lstattrbutes = data;
      this.sharedService.lstattrbutes = this.lstattrbutes;
      if (this.sharedService.lstattrbutes != null && this.sharedService.lstattrbutes.length > 0) {
        this.lstAlertPriority = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '15');
        this.lstAlertStatus = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '20');
        this.priorityfilter();
        this.statusfilter();
      }
    });

  }

  clearformcontrolvalues() {
    this.AlertDetailsForm.patchValue({
      alertDetails: '',
      chkScheduling: '',
      chkDemographics: '',
      chkClinical: '',
      chkBilling: '',
      chkMa: '',
      //  alertEffectiveDate: null,
      alertExpirationDate: null,
      alertPriority: '',
      //isChkRoles:''
      //  alertStatus: '',
      chkVisitNote: '',
      chkOrNote: '',
      chkRx: '',
      chkOrder: '',
    });
    this.alertId = 0;
    this.selected = '';
    this.selectedName = '';
  }
  todayDate = new Date();

  getAlertsInfo(id: number, locationId: number) {
    var visitDate = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy')
    this.personalService.getAlertsInfo(id, locationId)
      .subscribe(
        (data: any) => {
          this.lstAlertsInfo = data;
          if (this.lstAlertsInfo[0].roles != null && this.lstAlertsInfo[0].roles != undefined && this.lstAlertsInfo[0].roles != "") {
            this.selectedList = [];
            this.selected = ''; this.selectedName = ''; this.displayRoleName = '';
            const rolesSplit = this.lstAlertsInfo[0].roles.split(',');
            this.rolesList.filter(x => x.selected = false)
            rolesSplit.forEach(ele => {
              this.rolesList.filter(x => x.roleId == ele).map(y => y.selected = true)
            });
            this.selectedList = this.rolesList.filter(x => x.selected == true);
            for (let index = 0; index < this.selectedList.length; index++) {
              this.selected += this.selectedList[index].roleId + ',';
              this.selectedName += this.selectedList[index].roleName + ', ';
              this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
            }
            if (this.selectedList.length != 0) {
              this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
              this.selected = this.selected.substring(0, this.selected.length - 1);
              this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
            }
            this.AlertDetailsForm.patchValue({
              roles: this.displayRoleName
            });
            this.checkRole();

          }

          this.getPopupAlertsInfo(id, visitDate);

        },
        (err: any) => console.log(err)
      );
  }

  getPopupAlertsInfo(id: number, visitDate: any) {
    this.sharedService.getAlertsInfo(id, visitDate)
      .subscribe(
        (data: any) => {
          this.lstPopUpAlerts = data;
          this.sharedService.lstPopUpAlerts = this.lstPopUpAlerts;
          this.AuditLogs("USP_EMR_GET_PATIENT_ALERTS", CommonComponents.patientId);
        },
        (err: any) => console.log(err)
      );
  }

  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }
  logValidationErrors(group: FormGroup = this.AlertDetailsForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
  ColseAlert() {
    sessionStorage.removeItem("AlertsheaderIconVisibility");
    this.AlertsilderClose.emit()

  }
  isEditGapDisabled: boolean = false;
  oncellclick(element: IAlerts) {
    this.isEditGapDisabled = element.IsRCMAlert ? true : false;
    this.show = false;
    if (this.delAlertInfo === "delete") {
      this.expandedElement = null
    } else {
      this.AlertDetailsForm.patchValue({
        alertDetails: element.alertDetails,
        chkScheduling: element.isScheduling,
        chkDemographics: element.isDemographics,
        chkClinical: element.isClinical,
        //chkBilling: element.isBilling,
        //chkMa: element.isMA,
        // alertEffectiveDate: element.effectiveDate,
        // alertExpirationDate: element.exprirationDate,
        alertPriority: element.priorityId.toString(),
        alertStatus: element.alertStatusId.toString(),
        checkRole: element.isRole,
        //roles: element.rolesName
        roles: element.displayRoleName,
        chkVisitNote: element.isVisitNote,
        chkOrNote: element.isOrNote,
        chkRx: element.isRx,
        chkOrder: element.isOrderNote,
      });

      if (element.roles != "" && element.roles != null) {
        var lstrole = element.roles.split(',');
        this.rolesList.filter(x => x.selected = false)
        lstrole.forEach(ele => {
          this.rolesList.filter(x => x.roleId.toLowerCase() == ele.toLowerCase()).map(y => y.selected = true)
        });
        if (this.rolesList != null && this.rolesList.length > 0) {
          this.selected = '';
          this.selectedName = ''; this.displayRoleName = '';
          this.selectedList = this.rolesList.filter(x => x.selected === true);
          for (let index = 0; index < this.selectedList.length; index++) {
            this.selected += this.selectedList[index].roleId + ',';
            this.selectedName += this.selectedList[index].roleName + ', ';
            this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
          }
          if (this.selectedList.length != 0) {
            this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
            this.selected = this.selected.substring(0, this.selected.length - 1);
            this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
          }
        }
        this.checkRole();
      } else {
        this.AlertDetailsForm.patchValue({
          isChkRoles: false,
        })
        this.rolesList.filter(x => x.selected = false);
        this.selected = '';
        this.selectedName = '';
      }
      //alert(element.effectiveDate)
      //var str = this.datePipe.transform(element.effectiveDate, 'MM/dd/yyyy');
      if (element.effectiveDate == null || element.effectiveDate == undefined) {
        this.AlertDetailsForm.patchValue({
          alertEffectiveDate: '',
        })
      } else {
        this.AlertDetailsForm.patchValue({
          // alertEffectiveDate: new Date(element.effectiveDate), //datePipe.transform(value, 'MM/dd/yyyy')
          alertEffectiveDate: new Date(element.effectiveDate),
        })
      } if (element.exprirationDate == null || element.exprirationDate == undefined) {
        this.AlertDetailsForm.patchValue({
          alertExpirationDate: '',
        })
      } else {
        this.AlertDetailsForm.patchValue({
          alertExpirationDate: new Date(element.exprirationDate),
        })
      }

      this.alertId = element.alertId;
    }
  }

  onSubmit(id): void {
    // this.spinner.show();
    // alert("alert submit");
    // 
    if (CommonComponents.patientId > 0) {
      this.spinner.show();
      var effDate = this.datePipe.transform(this.AlertDetailsForm.value.alertEffectiveDate, 'yyyy-MM-dd');
      this.alertsInfo.effectiveDate = effDate != null ? new Date(effDate) : null;
      var termDate = this.datePipe.transform(this.AlertDetailsForm.value.alertExpirationDate, 'yyyy-MM-dd');
      this.alertsInfo.exprirationDate = termDate != null ? new Date(termDate) : null;
      if (this.alertsInfo.exprirationDate != null)
        if (this.alertsInfo.exprirationDate < this.alertsInfo.effectiveDate) {
          // if(new Date(this.AlertDetailsForm.value.alertExpirationDate) <  new Date(this.AlertDetailsForm.value.alertEffectiveDate)){
          const message = ' Expiration date should be greater than effective date ';
          const dialogData = new warningDialogModel('Alert !', message);
          const dialogRef = this.dialog.open(WarningDialogComponent, {
            width: '350px',
            height: '120px',
            data: dialogData
          });
          dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
          });
          this.spinner.hide();
          return;
        }

      this.alertsInfo.alertId = id;
      this.mapFormValuesToAlertsModel();
      if (this.alertsInfo.alertId) {
        this.personalService.updateAlertsInfo(this.alertsInfo).subscribe((results: any) => {
          this.result = results;
          this.show = false; this.expandedElement = null;
          this.getAlertsInfo(CommonComponents.patientId, this.locationid);
          this.alertId = 0;
          this.spinner.hide();
          this.toastr.success(this.result);
        });
      } else {
        this.spinner.show();
        this.personalService.addAlertsInfo(this.alertsInfo).subscribe(
          results => {
            this.result = results;
            this.show = false;
            this.getAlertsInfo(CommonComponents.patientId, this.locationid);
            this.alertId = 0;
            this.spinner.hide();
            this.toastr.success(this.result);

          });
      }
    }
    else {
      this.spinner.show();
      const message = ' Save Personal Info ';
      const dialogData = new warningDialogModel('Alert !', message);
      const dialogRef = this.dialog.open(WarningDialogComponent, {
        width: '250ppx',
        height: '130px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(dialogResult => {
        this.result = dialogResult;
        this.spinner.hide();
      });
    }
  }

  mapFormValuesToAlertsModel() {
    this.alertsInfo.alertDetails = this.AlertDetailsForm.value.alertDetails;
    this.alertsInfo.isScheduling = this.AlertDetailsForm.value.chkScheduling;
    this.alertsInfo.isDemographics = this.AlertDetailsForm.value.chkDemographics;
    this.alertsInfo.isClinical = this.AlertDetailsForm.value.chkClinical;
    this.alertsInfo.isRole = this.AlertDetailsForm.value.isChkRoles;

    this.alertsInfo.isVisitNote = this.AlertDetailsForm.value.chkVisitNote;
    this.alertsInfo.isOrNote = this.AlertDetailsForm.value.chkOrNote;
    this.alertsInfo.isRx = this.AlertDetailsForm.value.chkRx;
    this.alertsInfo.isOrderNote = this.AlertDetailsForm.value.chkOrder;
    //this.alertsInfo.isBilling = this.AlertDetailsForm.value.chkBilling;
    //this.alertsInfo.isMA = this.AlertDetailsForm.value.chkMa;
    // this.alertsInfo.effectiveDate = this.AlertDetailsForm.value.alertEffectiveDate;
    // var effDate = this.datePipe.transform(this.AlertDetailsForm.value.alertEffectiveDate,'yyyy-MM-dd');
    // this.alertsInfo.effectiveDate = effDate !=null ? new Date(effDate): null;
    // // this.alertsInfo.exprirationDate = this.AlertDetailsForm.value.alertExpirationDate;
    // var termDate = this.datePipe.transform(this.AlertDetailsForm.value.alertExpirationDate,'yyyy-MM-dd');
    // this.alertsInfo.exprirationDate = termDate !=null ? new Date(termDate): null;
    // this.alertsInfo.priorityId = this.AlertDetailsForm.value.alertPriority;
    //this.alertsInfo.alertStatusId = this.AlertDetailsForm.value.alertStatus;
    if (this.alertsInfo.alertId != 0) {
      this.alertsInfo.priorityId = this.AlertDetailsForm.value.alertPriority;
      this.alertsInfo.alertStatusId = this.AlertDetailsForm.value.alertStatus;
      this.alertsInfo.roles = this.selected;
      this.alertsInfo.rolesName = this.selectedName;
    } else {
      if (this.AlertDetailsForm.value.alertPriority != "" && this.AlertDetailsForm.value.alertPriority != null) {
        this.alertsInfo.priorityId = Number(this.apriorityId);
        this.alertsInfo.alertStatusId = Number(this.astatusId);
        this.alertsInfo.roles = this.selected;
        this.alertsInfo.rolesName = this.selectedName;
      } else {
        this.alertsInfo.priorityId = 0
        this.alertsInfo.alertStatusId = Number(this.astatusId);
        this.alertsInfo.roles = this.selected;
        this.alertsInfo.rolesName = this.selectedName;
      }
    }
    this.alertsInfo.isActive = true;
    this.alertsInfo.isDismiss = true;
    this.alertsInfo.patId = CommonComponents.patientId;
    this.alertsInfo.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.alertsInfo.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.alertsInfo.facilityId = Number(sessionStorage.getItem("FacilityId"));

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 47 || charCode > 57) {
      return false;
    }
    return true;

  }

  showInfo() {
    // this.popupVisible = true;
    //this.alertsDropdownBinding()
    this.AlertDetailsForm.patchValue({
      alertEffectiveDate: new Date(),
      alertStatus: "Active",
      isChkRoles: false,
      roles: ''

    });
    this.astatusId = '66';
    this.show = !this.show;
    this.clearformcontrolvalues();
    //this.DefaultRoleschecked();
    this.expandedElement = null;
    this.selectedList.forEach(element => {
      element.selected = false
    });
  }

  onCancelClick() {
    this.show = false;
    this.expandedElement = null;
  }

  deleteAlertsInfo(element: IAlerts, delNo: string) {
    this.delAlertInfo = delNo;
    const message = "Are you sure to delete Alert Information? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      width: '350px',
      height: '120px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.expandedElement = null;
      this.delAlertInfo = "";
      this.result = dialogResult;
      if (this.result) {

        this.personalService.DeleteSelectAlertInfo(element.alertId).subscribe(
          results => {
            this.result = results;
            this.getAlertsInfo(CommonComponents.patientId, this.locationid);
            this.toastr.success(this.result);
          });
        this.delAlertInfo = "";
      } else {
        this.result = dialogResult;
      }
    });
  }
  isdisablebtn: boolean = false;
  checkLock() {
    this.lockService.getLockUsers(encodeURIComponent(sessionStorage.getItem("userId")), Defaults.lock_demographics_alert, sessionStorage.getItem("FacilityId"), CommonComponents.patientId.toString()).subscribe(
      results => {
        this.lockedUser = results;
        if (this.lockedUser != null && this.lockedUser != undefined) {
          this.lockMessage = this.lockedUser.userName + " is working on this " + this.lockedUser.controlName + " form right now ";
          this.AlertDetailsForm.disable();
          this.isdisablebtn = true;
        }
      });
  }

  getSystem() {

    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("LocationId") != null || sessionStorage.getItem("LocationId") != undefined) {
      this.locationid = parseInt(sessionStorage.getItem("LocationId"));
    }
  }

  priorityfilter() {
    this.apriorityOptions = this.AlertDetailsForm.get('alertPriority')!.valueChanges.pipe(
      startWith(""),
      map(value => this._providers(value))
    );
  }
  private _providers(value: string): IAttributes[] {
    const filterValue = value.toString().toLowerCase();
    return this.lstAlertPriority.filter(option => option.attributeName.toLowerCase().indexOf(filterValue) === 0);
  }
  statusfilter() {
    this.astatusOptions = this.AlertDetailsForm.get('alertStatus')!.valueChanges.pipe(
      startWith(""),
      map(value => this._astatus(value))
    );
  }
  private _astatus(value: string): IAttributes[] {
    const filterValue = value.toString().toLowerCase();
    return this.lstAlertStatus.filter(option => option.attributeName.toLowerCase().indexOf(filterValue) === 0);
  }
  onSelectionChanged(event$, type: string) {
    setTimeout(() => {
      $(event$.target).prev().trigger('focus');
    }, 10);
    let autoval = event$;
    if (type === "alertPriority") {
      let aprioritylist = this.lstAlertPriority.filter(x => x.attributeName === autoval);
      if (aprioritylist.length != 0) {
        this.apriorityId = aprioritylist[0].attributeId.toString();
      } else {
        this.apriorityId = "0";
      }
    }
    else if (type === "alertStatus") {
      let statuslist = this.lstAlertStatus.filter(x => x.attributeName === autoval);
      if (statuslist.length != 0) {
        this.astatusId = statuslist[0].attributeId.toString();
      } else {
        this.astatusId = "0";
      }
    }
  }
  fnShowDropDownListAl1(i) {
    return this.SelectedDropDownListId == i.toString();
  }
  focusOutFunctionroles(evn) {
    if (evn.keyCode === 9) {
      $('#rolesfocushide').hide();

    } else if (evn.keyCode === 40 && evn.target.id == "rolesfocus") {

      $('#roleslistoption0').focus();

    }
  }
  @ViewChildren('dateInput') dateInput: QueryList<ElementRef>;
  focusOutFunctionrolesUpdate(evn, i) {
    if (evn.keyCode === 9) {
      $('#rolesfocushide' + i).hide()
      this.SelectedDropDownListId = '';

      setTimeout(() => {
        (this.dateInput.toArray())[i].nativeElement.focus();
      }, 100);

    } else if (evn.keyCode === 40 && evn.target.id == "updaterolesfocus" + i) {
      $('#userselectLoc0_' + i).focus();
    }
  }
  public isshowDrugReactionFocusEnabled: boolean = false;
  tabshowreactionFocus(i) {
    this.isshowDrugReactionFocusEnabled = true;
    $('#rolesfocushide' + i).hide();
    this.SelectedDropDownListId = 'updaterolesfocus' + i.toString();

  }
  rolesSelectionChanged(event, rolesRef) {
    this.selectedList = rolesRef.selectedOptions.selected.map(item => item.value);
    this.rolesList.filter(x => x.selected = false)
    this.selectedList.forEach(element => {
      this.rolesList.filter(x => x.roleId == element.roleId).map(y => y.selected = true)
    });
    this.selected = '';
    this.selectedName = ''; this.displayRoleName = '';
    for (let index = 0; index < this.selectedList.length; index++) {
      this.selected += this.selectedList[index].roleId + ',';
      this.selectedName += this.selectedList[index].roleName + ', ';
      this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
    }
    if (this.selectedList.length != 0) {
      this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
      this.selected = this.selected.substring(0, this.selected.length - 1);
      this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
    }
    this.AlertDetailsForm.patchValue({
      roles: this.displayRoleName
    });
    this.checkRole();
  }

  rolesUpdateSelectionChanged(event, rolesUpdateRef) {
    this.selectedList = rolesUpdateRef.selectedOptions.selected.map(item => item.value);
    this.rolesList.filter(x => x.selected = false)
    this.selectedList.forEach(element => {
      this.rolesList.filter(x => x.roleId == element.roleId).map(y => y.selected = true)
    });
    this.selected = '';
    this.selectedName = ''; this.displayRoleName = '';
    for (let index = 0; index < this.selectedList.length; index++) {
      this.selected += this.selectedList[index].roleId + ',';
      this.selectedName += this.selectedList[index].roleName + ', ';
      this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
    }
    if (this.selectedList.length != 0) {
      this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
      this.selected = this.selected.substring(0, this.selected.length - 1);
      this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
    }
    this.AlertDetailsForm.patchValue({
      roles: this.displayRoleName
    });
    this.checkRole();
  }
  checkRole() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectRolelst = this.selectedList.filter(x => x.selected == true);
      if (selectRolelst.length === this.rolesList.length) {
        this.AlertDetailsForm.patchValue({
          isChkRoles: true
        });
      } else {
        this.AlertDetailsForm.patchValue({
          isChkRoles: false
        });
      }
    } else {
      this.AlertDetailsForm.patchValue({
        isChkRoles: false
      });
    }
  }
  UsersFocus() {
    $('#rolesfocushide').show();
    $('.mat-selection-list').scrollTop(0);

  }
  UsersFocusUpdate(i) {
    $(".rolesfocushideClass").hide();
    this.isshowDrugReactionFocusEnabled = true;
    $('#rolesfocushide' + i).show();

    this.SelectedDropDownListId = 'updaterolesfocus' + i.toString();
  }
  selectedList: IRole[] = [];
  selected: string = "";
  selectedName: string;
  displayRoleName: string;
  checkAllRoles(event) {
    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      this.selectedList = [];
      this.selectedroleIds = [];
      this.selected = '';
      this.selectedName = ''; this.displayRoleName = '';
      this.selectedList = this.rolesList.filter(x => x.selected = true);

      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = true;
        this.selected += this.selectedList[index].roleId + ',';
        this.selectedroleIds.push(this.selectedList[index].roleId.toString())
        this.selectedName += this.selectedList[index].roleName + ', ';
        this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
        this.selected = this.selected.substring(0, this.selected.length - 1);
        this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
      }
      this.AlertDetailsForm.patchValue({
        roles: this.displayRoleName
      });
    } else {
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.selectedroleIds = [];
      this.selected = '';
      this.selectedName = ''; this.displayRoleName = '';
      this.AlertDetailsForm.patchValue({
        roles: this.displayRoleName
      });
    }
  }
  selectedrole: string = "";
  roleNameUpdate: string;
  selectedroleName: string;
  selectedroleIds: string[] = [];
  DefaultRoleschecked() {
    this.selectedList = [];
    this.selected = '';
    this.selectedName = ''; this.displayRoleName = '';
    this.selectedList = this.rolesList.filter(x => x.selected = true);
    if (this.rolesList != null && this.rolesList.length > 0) {
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selected += this.selectedList[index].roleId + ',';
        this.selectedName += this.selectedList[index].roleName + ', ';
        this.displayRoleName += this.selectedList[index].displayRoleName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.selectedName = this.selectedName.substring(0, this.selectedName.length - 2);
        this.selected = this.selected.substring(0, this.selected.length - 1);
        this.displayRoleName = this.displayRoleName.substring(0, this.displayRoleName.length - 2);
      }
      this.AlertDetailsForm.patchValue({
        roles: this.displayRoleName
      });
      sessionStorage.setItem("selectedrols", this.selected);
    }
    this.checkRole();
  }
}
export interface PeriodicElement {
  AlertDetails: string;
  Priority: string;
  EffectiveDate: string;
  ExpirationDate: string;
  Action: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { AlertDetails: 'Hi', Priority: 'High', EffectiveDate: '7/12/2019', ExpirationDate: '8/11/2019', Action: '' },
  { AlertDetails: 'Hi', Priority: 'Medium', EffectiveDate: '8/11/2019', ExpirationDate: '9/9/2019', Action: '' },
  { AlertDetails: 'Hi', Priority: 'Low', EffectiveDate: '9/9/2019', ExpirationDate: '12/9/2019', Action: '' },
];
